import { RectangleStackIcon } from '@heroicons/react/24/outline';

import { useTreeCourses } from '@/data/context/TreeCoursesContext';
import {
  adapterCourseNodeToBreadcrumbItem,
  BreadcrumbItem,
} from '@/data/hook/useDynamicBreadcrumbItems';
import Activity from '@/models/Activity';
import { mountKey } from '@/utils/courses';

type UseLessonQuestionBreadcrumbProps = {
  activity: Activity;
  lessonId: number;
};

const useLessonQuestionBreadcrumb = ({
  activity,
  lessonId,
}: UseLessonQuestionBreadcrumbProps): BreadcrumbItem[] => {
  const { tree } = useTreeCourses();

  const path = tree?.current.findPath(
    mountKey({ type: 'lesson', id: lessonId }),
  );
  const parentItems = path?.slice(-2)?.map(adapterCourseNodeToBreadcrumbItem) ?? [];

  return [
    ...parentItems,
    {
      id: `activity-${activity.id}`,
      children: activity.name,
      icon: <RectangleStackIcon className="h-4 w-4" />,
    },
  ];
};

export default useLessonQuestionBreadcrumb;
